








































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import IStock from '@/store/models/IStock';
import FilterMenu from '@/components/shared/FilterMenu.vue';
import { uniq } from "lodash";
import moment from 'moment';
import ICustomer from '@/store/models/ICustomer';
import IListPalletType from '@/store/models/IListPalletType';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import IAuthentication from '@/store/models/IAuthentication';
import ISettingsCompany from '@/store/models/ISettingsCompany';

type ExportHeader = {
    text: string;
    value: string;
};

type ExportColumnSetting = {
    key: string;
    header: string;
    order: number;
    format?: "date" | "boolean" | "string" | "number";
    source?: "item" | "selectedCustomer";
};

@Component({
    components: {
        Snackbar,
        FilterMenu
    }
})
export default class StockCustomerSelector extends Vue {
    @Prop({ type: Array, required: true })
    CustomersList!: ICustomer[];
    @Prop({ type: Array, required: true })
    Permissions!: IRolePermission[];
    @Prop({ type: Array, required: true })
    StockList!: IStock[];
    @Prop({ type: Array, required: true })
    ListPalletTypes!: IListPalletType[];
    @Prop({ type: Boolean, required: true })
    CustomerStockCustomFieldsActive!: boolean;
    @Prop({ type: Boolean, required: true })
    VisiblePrintBtn!: Boolean;
    @Prop({ type: Boolean, required: true })
    ShowSku!: boolean;

    inboundCodeFilter: string[] = [];
    inboundCodeDestinationFilter: string[] = [];
    goodFilter: string[] = [];
    palletFilter: string[] = [];
    warehouseNameFilter: string[] = [];
    bestBeforeDateFilter: Date[] = [];
    groupByActive: boolean = false;
    stockError: string[] = [];
    location: string = "";
    dialog: boolean = false;
    dialogPrinting: boolean = false;
    selectedFormatToPrint: string = "excel";
    customerSelected: ICustomer = {} as ICustomer;
    sortBy: string = 'goodName';
    sortDesc: boolean = false;
    goodCodeFilter: string[] = [];

    get headerCustom() {
        if (this.groupByActive) {
            const headers = [
                { text: 'Good', align: 'start', value: 'goodName' },
                { text: 'Good Code', align: 'start', value: 'goodCode' },
                { text: 'Dossier Number Source', value: 'codeInbounds' },
                { text: 'Dossier Number Destination', value: 'codeDestination' },
                { text: 'Date In', value: 'dateIn' },
                { text: 'Weight', value: 'weight' },
                { text: 'Warehouse', value: 'warehouseName' },
                { text: 'Location', value: 'location', sortable: false },
                { text: 'Pallet type', value: 'listPalletName' },
                { text: 'Total pallets', value: 'palletsAmount' },
                { text: 'Sell pallets', value: 'palletsAmountSell' },
                { text: 'Available pallets', value: 'availablePalletsAmountFinal' },
                { text: 'Total cases', value: 'totalCases' },
                { text: 'Cases Allocated', value: 'allocatedCases' },
                { text: 'Cases sell', value: 'sellCases' },
                { text: 'Available Cases', value: 'availableCasesFinal' },
                { text: 'Total goods', value: 'totalGoods' },
                { text: 'Goods Allocated', value: 'allocatedGoods' },
                { text: 'Goods sell', value: 'sellGoods' },
                { text: 'Available Goods', value: 'availableGoodsFinal' },
                { text: 'BestBeforeDate', value: 'bestBeforeDate' },
                { text: 'Language', value: 'language' },
                { text: 'Reference dossier number', value: 'referenceInboundCode' },
                { text: 'Documentation', value: 'documentation' }
            ];

            if (this.ShowSku) {
                const goodCodeIndex = headers.findIndex(h => h.value === 'goodCode');
                if (goodCodeIndex !== -1) {
                    headers.splice(goodCodeIndex + 1, 0, {
                        text: 'SKU',
                        value: 'sku'
                    });
                }
            }

            return this.applyCustomerCustomFields(headers);
        } else {
            const headers = [
                { text: 'Good', align: 'start', value: 'goodName' },
                { text: 'Good Code', align: 'start', value: 'goodCode' },
                { text: 'Dossier Number Source', value: 'codeInbounds' },
                { text: 'Dossier Number Destination', value: 'codeDestination' },
                { text: 'Date In', value: 'dateIn' },
                { text: 'Weight', value: 'weight' },
                { text: 'Warehouse', value: 'warehouseName' },
                { text: 'Location', value: 'location', sortable: false },
                { text: 'Pallet type', value: 'listPalletName' },
                { text: 'Total pallets', value: 'palletsAmount' },
                { text: 'Total cases', value: 'totalCases' },
                { text: 'Goods per case', value: 'goodsPerCase' },
                { text: 'Total goods', value: 'totalGoods' },
                { text: 'BestBeforeDate', value: 'bestBeforeDate' },
                { text: 'Language', value: 'language' },
                { text: 'Reference dossier number', value: 'referenceInboundCode' },
                { text: 'Documentation', value: 'documentation' }
            ];

            if (this.ShowSku) {
                const goodCodeIndex = headers.findIndex(h => h.value === 'goodCode');
                if (goodCodeIndex !== -1) {
                    headers.splice(goodCodeIndex + 1, 0, {
                        text: 'SKU',
                        value: 'sku'
                    });
                }
            }

            return this.applyCustomerCustomFields(headers);
        }
    }

    GetValueDocumentation(documentationNeeded: boolean) {
        if (documentationNeeded !== null && documentationNeeded !== undefined) {
            if (documentationNeeded.toString() === 'true') {
                return 'Yes';
            } else {
                return 'No';
            }
        }

        return 'No';
    }

    get CustomersListSortered() {
        return this.CustomersList.sort((n1, n2) => {
            if (n1.name > n2.name) {
                return 1;
            }

            if (n1.name < n2.name) {
                return -1;
            }

            return 0;
        });
    }

    get TotalCases() {
        return this.stockItemsFiltered.reduce((sum, current) => Number(sum) + Number(current.totalCases), 0);
    }

    get TotalPallets() {
        return this.stockItemsFiltered
        .filter(i => this.isBillablePalletType((i as any).listPalletName))
        .reduce((sum, current) => Number(sum) + Number((current as any).palletsAmount), 0);
    }

    get TotalGoods() {
        return this.stockItemsFiltered.reduce((sum, current) => Number(sum) + Number(current.totalGoods), 0);
    }

    get goodCodes(): string[] {
        return uniq(
            this.StockList
            .filter(b => b.goodCode !== null && b.goodCode !== undefined)
            .map(b => b.goodCode as any)
        );
    }

    customSort(items: IStock[], sortBy: any, sortDesc: any): IStock[] {
        const itemsCopy = [...items];

        const sortKey = Array.isArray(sortBy) ? sortBy[0] : sortBy;
        const desc = Array.isArray(sortDesc) ? sortDesc[0] : sortDesc;

        if (!sortKey) {
            return itemsCopy;
        }

        itemsCopy.sort((x: IStock, y: IStock) => {
            const ax = this.getSortValue(x, sortKey);
            const ay = this.getSortValue(y, sortKey);
            const cmp = this.compareValues(ax, ay);
            return desc ? -cmp : cmp;
        });

        return itemsCopy;
    }

    getLocations(location: string | null | undefined): string[] {
        if (!location) return [];

        return Array.from(
            new Set(
                String(location)
                .split('|')
                .map(x => x.trim())
                .filter(x => x !== "")
            )
        );
    }

    getLocationPreview(location: string | null | undefined): string {
        const locations = this.getLocations(location);

        if (locations.length === 0) return "";
        if (locations.length === 1) return locations[0];
        if (locations.length === 2) return `${locations[0]}, ${locations[1]}`;

        return `${locations[0]}, ${locations[1]} +${locations.length - 2}`;
    }

    hasMultipleLocations(location: string | null | undefined): boolean {
        return this.getLocations(location).length > 1;
    }

    getStock() {
        if (Object.keys(this.customerSelected).length !== 0) {
            this.groupByActive = false;
            this.$emit('getStockSelectedCustomer', this.customerSelected);
        }
    }

    ToDateFormat(dateStr: any): string {
        if (!dateStr) return "";

        let d: moment.Moment;

        if (dateStr instanceof Date) {
            d = moment(dateStr);
        } else if (typeof dateStr === "string") {
            const trimmed = dateStr.trim();
            d = moment(trimmed, ["DD/MM/YYYY", "D/M/YYYY", "YYYY-MM-DD", moment.ISO_8601], true);
        } else {
            return "";
        }

        if (!d.isValid()) return "";

        return d.format("DD-MM-YYYY");
    }

    private applyCustomerCustomFields(headers: Array<{ text: string; value: string; align?: string }>) {
        if (!this.CustomerStockCustomFieldsActive) return headers;

        const columnsToRemove = new Set([
            "palletsAmountSell",
            "sellCases",
            "sellGoods",
            "documentation",
            "codeDestination",
            "goodsPerCase",
            "totalGoods",
            "referenceInboundCode"
        ]);

        return headers
        .filter(h => !columnsToRemove.has(h.value))
        .map(h => {
            if (h.value === "language") {
                return Object.assign({}, h, { text: "Batch" });
            }
            return h;
        });
    }

    @Watch('groupByActive')
    onChangeGroupByActive() {
        if (Object.keys(this.customerSelected).length === 0) {
            this.showMessageWarning("Please select a customer");
        } else {
            this.$emit('groupByPalletAndCustomer', this.customerSelected, this.groupByActive);
        }
    }

    get bestBeforeDates(): Date[] {
        return uniq(
            this.StockList
            .filter(b => b.bestBeforeDate !== null)
            .map(b => b.bestBeforeDate)
        );
    }

    get warehouseNames(): string[] {
        return uniq(
            this.StockList
            .filter(b => b.warehouseName !== null)
            .map(b => b.warehouseName)
        );
    }

    get inboundCodes(): string[] {
        return uniq(
            this.StockList
            .filter(b => b.codeInbounds !== null)
            .map(b => b.codeInbounds)
        );
    }

    get goodNames(): string[] {
        return uniq(
            this.StockList
            .filter(b => b.goodName !== null)
            .map(b => b.goodName)
        );
    }

    get inboundCodeDestinations(): string[] {
        return uniq(
            this.StockList
            .filter(b => b.codeDestination !== null)
            .map(b => b.codeDestination)
        );
    }

    get palletNames(): string[] {
        return uniq(
            this.StockList
            .filter(b => b.listPalletName !== null)
            .map(b => b.listPalletName)
        );
    }

    get stockItemsFiltered(): IStock[] {
        let filteredList = this.StockList;

        if (this.inboundCodeFilter.length > 0) {
            filteredList = filteredList.filter(b => this.inboundCodeFilter.includes(b.codeInbounds));
        }
        if (this.goodFilter.length > 0) {
            filteredList = filteredList.filter(b => this.goodFilter.includes(b.goodName));
        }
        if (this.palletFilter.length > 0) {
            filteredList = filteredList.filter(b => this.palletFilter.includes(b.listPalletName));
        }
        if (this.warehouseNameFilter.length > 0) {
            filteredList = filteredList.filter(b => this.warehouseNameFilter.includes(b.warehouseName));
        }
        if (this.bestBeforeDateFilter.length > 0) {
            filteredList = filteredList.filter(b => this.bestBeforeDateFilter.includes(b.bestBeforeDate));
        }
        if (this.inboundCodeDestinationFilter.length > 0) {
            filteredList = filteredList.filter(b => this.inboundCodeDestinationFilter.includes(b.codeDestination));
        }
        if (this.goodCodeFilter.length > 0) {
            filteredList = filteredList.filter(b => this.goodCodeFilter.includes((b as any).goodCode));
        }
        return filteredList;
    }

    getBestBeforeStatus(dateStr: any): "expired" | "soon" | "normal" {
        if (!dateStr) return "normal";

        const today = moment().startOf("day");
        let date: moment.Moment;

        if (dateStr instanceof Date) {
            date = moment(dateStr).startOf("day");
        } else if (typeof dateStr === "string") {
            const trimmed = dateStr.trim();
            date = moment(trimmed, ["DD/MM/YYYY", "D/M/YYYY", "YYYY-MM-DD", moment.ISO_8601], true)
            .startOf("day");
        } else {
            return "normal";
        }

        if (!date.isValid()) {
            console.warn("Invalid bestBeforeDate:", dateStr);
            return "normal";
        }

        if (date.isBefore(today)) {
            return "expired";
        }

        const diffDays = date.diff(today, "days");

        if (diffDays >= 0 && diffDays < 90) {
            return "soon";
        }

        return "normal";
    }

    getBestBeforeColor(status: "expired" | "soon" | "normal") {
        switch (status) {
            case "expired":
                return "red darken-2";
            case "soon":
                return "yellow darken-2";
            default:
                return "blue-grey lighten-2";
        }
    }

    clearAllFilters(): void {
        this.inboundCodeFilter = [];
        this.inboundCodeDestinationFilter = [];
        this.goodFilter = [];
        this.palletFilter = [];
        this.bestBeforeDateFilter = [];
        this.warehouseNameFilter = [];
        this.goodCodeFilter = [];
        this.showMessageInfo("All filters have been deselected");
    }

    private parseMomentSafe(dateStr: any): moment.Moment | null {
        if (!dateStr) return null;

        if (dateStr instanceof Date) {
            const m = moment(dateStr);
            return m.isValid() ? m : null;
        }

        if (typeof dateStr === "string") {
            const trimmed = dateStr.trim();
            const m = moment(trimmed, ["DD/MM/YYYY", "D/M/YYYY", "YYYY-MM-DD", moment.ISO_8601], true);
            return m.isValid() ? m : null;
        }

        return null;
    }

    private getSortValue(item: IStock, key: string): any {
        const v: any = (item as any)[key];

        if (key === "dateIn" || key === "bestBeforeDate") {
            const m = this.parseMomentSafe(v);
            return m ? m.valueOf() : Number.MAX_SAFE_INTEGER;
        }

        if (key === "documentation") {
            return this.GetValueDocumentation(v);
        }

        return (v === null || v === undefined) ? "" : v;
    }

    private compareValues(a: any, b: any): number {
        const aEmpty = a === null || a === undefined || a === "";
        const bEmpty = b === null || b === undefined || b === "";
        if (aEmpty && bEmpty) return 0;
        if (aEmpty) return 1;
        if (bEmpty) return -1;

        if (typeof a === "number" && typeof b === "number") {
            return a - b;
        }

        const as = String(a).toLowerCase();
        const bs = String(b).toLowerCase();
        return as.localeCompare(bs);
    }

    private getOrderedItemsForExport(): IStock[] {
        return this.customSort(
            [...this.stockItemsFiltered],
            this.sortBy,
            this.sortDesc
        );
    }

    private parseExportColumnsSetting(settingValue: string): ExportColumnSetting[] {
        if (!settingValue || settingValue.trim() === "") {
            return [];
        }

        try {
            const parsed = JSON.parse(settingValue) as ExportColumnSetting[];

            if (!Array.isArray(parsed)) {
                return [];
            }

            return parsed
            .filter(c =>
                c &&
                typeof c.key === "string" &&
                typeof c.header === "string" &&
                typeof c.order === "number"
            )
            .filter(c => c.key !== "dateIn")
            .sort((a, b) => a.order - b.order);
        } catch (error) {
            console.error("Invalid export setting JSON", error);
            return [];
        }
    }

    private resolveExportColumnValue(item: IStock, column: ExportColumnSetting): any {
        let value: any = "";

        if (column.source === "selectedCustomer") {
            if (column.key === "customerName") {
                value = this.customerSelected && this.customerSelected.name
                    ? this.customerSelected.name
                    : "";
            }
        } else {
            value = (item as any)[column.key];
        }

        // Nueva regla:
        // La columna Aantart (key = totalCases) debe mostrar siempre el weight en Kg
        if (column.key === "totalCases") {
            const weight = item && item.weight !== null && item.weight !== undefined
                ? item.weight
                : 0;

            return `${weight} Kg`;
        }

        switch (column.format) {
            case "date":
                return this.ToDateFormat(value);
            case "boolean":
                return this.GetValueDocumentation(value);
            case "number":
                return value !== null && value !== undefined ? value : 0;
            case "string":
            default:
                return value !== null && value !== undefined ? value : "";
        }
    }

    private buildExportDataFromSetting(sortedList: IStock[], columns: ExportColumnSetting[]) {
        const visibleColumns = columns
        .filter(c => c.order > 0)
        .sort((a, b) => a.order - b.order);

        const rows = sortedList.map((item: IStock) => {
            const row: any = {};

            visibleColumns.forEach((column) => {
                row[column.header] = this.resolveExportColumnValue(item, column);
            });

            return row;
        });

        const totals: any = {};
        visibleColumns.forEach((column) => {
            totals[column.header] = "";
        });

        const totalCasesColumn = visibleColumns.find(c => c.key === "totalCases");
        const totalPalletsColumn = visibleColumns.find(c => c.key === "palletsAmount");
        const totalGoodsColumn = visibleColumns.find(c => c.key === "totalGoods");

        if (totalCasesColumn) {
            totals[totalCasesColumn.header] = this.TotalCases;
        }

        if (totalPalletsColumn) {
            totals[totalPalletsColumn.header] = this.TotalPallets;
        }

        if (totalGoodsColumn) {
            totals[totalGoodsColumn.header] = this.TotalGoods;
        }

        rows.push(totals);

        return {
            headers: visibleColumns.map(c => c.header),
            rows
        };
    }

    private normalizePalletName(name: any): string {
        const safe = (name === null || name === undefined) ? "" : String(name);
        return safe.trim().toLowerCase();
    }

    private isBillablePalletType(palletName: any): boolean {
        const nameNorm = this.normalizePalletName(palletName);

        if (!nameNorm) return true;

        const found = (this.ListPalletTypes || []).find(pt =>
            this.normalizePalletName((pt as any).name) === nameNorm
        );

        if (!found) return true;

        return !found.notBillable;
    }

    async printStock() {
        const userFromStorage: IAuthentication = JSON.parse(sessionStorage.getItem("user") || "{}");

        if (!this.customerSelected || !this.customerSelected.id) {
            this.showMessageWarning("Please select a customer");
            return;
        }

        const settingsCompanyApi = new SettingsCompanyApi("Customers");

        const settingKey =
            this.groupByActive
                ? String(SettingsCompany.Settings.CustomerStockGroupByOrderFields || "") + String(this.customerSelected.id || "")
                : String(SettingsCompany.Settings.CustomerStockOrderFields || "") + String(this.customerSelected.id || "");

        const setting: ISettingsCompany[] =
            await settingsCompanyApi.getSettingCompanyId(userFromStorage.idCompany, settingKey);

        const settingValue =
            (setting && setting.length > 0 && setting[0] && setting[0].value)
                ? String(setting[0].value).trim()
                : "";

        const exportColumns = this.parseExportColumnsSetting(settingValue);
        const ordered = this.getOrderedItemsForExport();

        let exportData: any;

        if (exportColumns.length > 0) {
            exportData = this.buildExportDataFromSetting(ordered, exportColumns);
        } else {
            exportData = this.buildExportDataFromVisibleTable(ordered);
        }

        this.$emit("printStockNew", exportData);
    }

    private buildExportDataFromVisibleTable(sortedList: IStock[]) {
        const visibleHeaders = (this.headerCustom as any[]).map((h: any) => ({
            text: String(h.text),
            value: String(h.value)
        }));

        const rows = sortedList.map((item: IStock) => {
            const row: any = {};

            visibleHeaders.forEach((h: { text: string; value: string }) => {
                let value: any = (item as any)[h.value];

                if (h.value === "dateIn" || h.value === "bestBeforeDate") {
                    value = this.ToDateFormat(value);
                }

                if (h.value === "documentation") {
                    value = this.GetValueDocumentation(value);
                }

                row[h.text] = value !== null && value !== undefined ? value : "";
            });

            return row;
        });

        const totals: any = {};
        visibleHeaders.forEach((h: { text: string; value: string }) => {
            totals[h.text] = "";
        });

        const totalPalletsHeader = visibleHeaders.find((h: { text: string; value: string }) => h.value === "palletsAmount");
        const totalCasesHeader = visibleHeaders.find((h: { text: string; value: string }) => h.value === "totalCases");
        const totalGoodsHeader = visibleHeaders.find((h: { text: string; value: string }) => h.value === "totalGoods");

        if (totalPalletsHeader) {
            totals[totalPalletsHeader.text] = this.TotalPallets;
        }

        if (totalCasesHeader) {
            totals[totalCasesHeader.text] = this.TotalCases;
        }

        if (totalGoodsHeader) {
            totals[totalGoodsHeader.text] = this.TotalGoods;
        }

        rows.push(totals);

        return {
            headers: visibleHeaders.map((h: { text: string; value: string }) => h.text),
            rows
        };
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }

    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
